import BasePolicy from '@/policies/BasePolicy.js';

export default class TermTemplatePolicy extends BasePolicy {
    viewAny(user) {
        const permission = 'view all term templates';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    view(user, termTemplate) {
        const permission = 'view a term template';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(termTemplate);
        }

        return user.hasPermissionTo(permission);
    }

    create(user) {
        const permission = 'create a term template';

        if (user.hasGroupPermissionTo(permission)) {
            return false;
        }

        return user.hasPermissionTo(permission);
    }

    update(user, termTemplate) {
        const permission = 'edit a term template';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(termTemplate);
        }

        return user.hasPermissionTo(permission);
    }

    delete(user) {
        const permission = 'delete a term template';

        return user.hasPermissionTo(permission);
    }
}
